export const EDITOR_INPUT_STYLE =
  'box-sizing:border-box;width:100%;padding:7px;border:1px solid #ccc;border-radius:4px;font:inherit;';
export const EDITOR_BUTTON_STYLE =
  'width:auto;height:auto;padding:7px 10px;border:1px solid #ccc;border-radius:4px;background:white;cursor:pointer;font:inherit;text-transform:uppercase;';
export const EDITOR_PRIMARY_STYLE = 'background:#476873;color:white;';
export function styleEditorContainer(element: HTMLElement, width = 'min(300px,65vw)') {
  element.style.cssText = `width:${width};box-sizing:border-box;display:flex;flex-direction:column;gap:10px;font:13px/1.4 system-ui,sans-serif;padding:6px;margin:0px;`;
}
